import React from "react";
import { withModal } from "../";

const ElectronicW9Modal = ({ context: { closeModal }, ...rest }) => (
  <div
    className="relative bg-white outline-none w-auto h-auto p-10 max-h-screen overflow-auto m-auto"
    style={{ maxHeight: 600, maxWidth: "80%" }}
  >
    <div className="text-center text-2xl p-8">Eletronic W9 Certification</div>
    <div className="w-5/6 m-auto">
      <p>
        By providing us your TIN (Taxpayer Identification Number) or SSN (Social
        Security Number), you must agree to the following statement:
      </p>
      <br />
      <p>I certify, under penalty of perjury that:</p>
      <p>
        The Taxpayer Identification Number or Social Security Number I provided
        is correct; I am not subject to backup withholding because: (a) I am
        exempt from backup withholding, or (b) I have not been notified by the
        Internal Revenue Service (IRS) that I am subject to backup withholding
        as a result of a failure to report all interest or dividends, or (c) the
        IRS has notified me that I am no longer subject to backup withholding;
        and I am a U.S. citizen or other U.S. person
      </p>
      <br />
      <p>
        The Internal Revenue Service does not require your consent to any
        provision of this document other than the certifications required to
        avoid backup withholding.
      </p>
    </div>
    <button
      className="absolute top-0 right-0 bg-gray-200 text-white text-2xl m-1 w-10 h-10"
      onClick={closeModal}
    >
      x
    </button>
  </div>
);

export default withModal(ElectronicW9Modal);
